{
  "MACROS": {
    "HEADER": "Makrók",
    "DESCRIPTION": "A macro is a set of saved actions that help customer service agents easily complete tasks. The agents can define a set of actions like tagging a conversation with a label, sending an email transcript, updating a custom attribute, etc., and they can run these actions in a single click.",
    "LEARN_MORE": "Learn more about macros",
    "COUNT": "{n} macro | {n} macros",
    "HEADER_BTN_TXT": "Új makró hozzáadása",
    "HEADER_BTN_TXT_SAVE": "Makró mentése",
    "LOADING": "Makrók lekérdezése",
    "SEARCH_PLACEHOLDER": "Search macros...",
    "NO_RESULTS": "No macros found matching your search",
    "ERROR": "Valami elromlott, kérjük töltsd próbáld újra",
    "ORDER_INFO": "A makrók a műveletek hozzáadásának sorrendjében fognak futni. A makrókat áthúzással át tudod rendezni.",
    "ADD": {
      "FORM": {
        "NAME": {
          "LABEL": "Makró neve",
          "PLACEHOLDER": "Írd ide a makród nevét",
          "ERROR": "Név megadása szükséges a makró létrehozásához"
        },
        "ACTIONS": {
          "LABEL": "Műveletek"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Makró sikeresen hozzáadva",
        "ERROR_MESSAGE": "Nem lehet létrehozni a makrót. Kérlek, próbáld újra később"
      }
    },
    "LIST": {
      "TABLE_HEADER": {
        "NAME": "Név",
        "CREATED BY": "Létrehozta",
        "LAST_UPDATED_BY": "Utoljára szerkesztette:",
        "VISIBILITY": "Láthatóság",
        "ACTIONS": "Műveletek"
      },
      "404": "Nem találtunk makrót"
    },
    "DELETE": {
      "TOOLTIP": "Makró törlése",
      "CONFIRM": {
        "MESSAGE": "Biztos abban, hogy törli ",
        "YES": "Igen, Törlés",
        "NO": "Nem"
      },
      "API": {
        "SUCCESS_MESSAGE": "Makró sikeresen törölve",
        "ERROR_MESSAGE": "Hiba történt a makró törlése közben. Kérlek próbáld újra később"
      }
    },
    "VIEW": {
      "TOOLTIP": "View macro"
    },
    "EDIT": {
      "TOOLTIP": "Makró szerkesztése",
      "API": {
        "SUCCESS_MESSAGE": "Makró frissítve",
        "ERROR_MESSAGE": "Nem sikerült frissíteni a makrót, kérlek próbáld újra később"
      }
    },
    "EDITOR": {
      "START_FLOW": "Flow indítása",
      "END_FLOW": "Flow befejezése",
      "LOADING": "Makró betöltése",
      "ADD_BTN_TOOLTIP": "Akció hozzáadása",
      "DELETE_BTN_TOOLTIP": "Akció törlése",
      "VISIBILITY": {
        "LABEL": "Makró láthatósága",
        "GLOBAL": {
          "LABEL": "Nyilvános",
          "DESCRIPTION": "Ez a makró nyilvánosan elérhető minden ügynök számára ebben a fiókban.",
          "CREATE_DISABLED_DESCRIPTION": "Only administrators can create public macros.",
          "EDIT_DISABLED_DESCRIPTION": "Csak adminisztrátorok tudnak publikus makrókat szerkeszteni."
        },
        "PERSONAL": {
          "LABEL": "Privát",
          "DESCRIPTION": "Ez a makró privát, csak Te látod és nem lesz elérhető mások számára."
        }
      }
    },
    "EXECUTE": {
      "BUTTON_TOOLTIP": "Futtatás",
      "PREVIEW": "Makró előnézet",
      "EXECUTED_SUCCESSFULLY": "Makró végrehajtása sikeres"
    },
    "ERRORS": {
      "ATTRIBUTE_KEY_REQUIRED": "Attribute key is required",
      "FILTER_OPERATOR_REQUIRED": "Filter operator is required",
      "VALUE_REQUIRED": "Kötelező megadni",
      "VALUE_MUST_BE_BETWEEN_1_AND_998": "Value must be between 1 and 998",
      "ACTION_PARAMETERS_REQUIRED": "Action parameters are required",
      "ATLEAST_ONE_CONDITION_REQUIRED": "At least one condition is required",
      "ATLEAST_ONE_ACTION_REQUIRED": "At least one action is required"
    },
    "ACTIONS": {
      "ASSIGN_TEAM": "Assign a Team",
      "ASSIGN_AGENT": "Assign an Agent",
      "ADD_LABEL": "Add a Label",
      "REMOVE_LABEL": "Remove a Label",
      "REMOVE_ASSIGNED_AGENT": "Remove Assigned Agent",
      "REMOVE_ASSIGNED_TEAM": "Remove Assigned Team",
      "SEND_EMAIL_TRANSCRIPT": "Send an Email Transcript",
      "MUTE_CONVERSATION": "Beszélgetés elnémítása",
      "SNOOZE_CONVERSATION": "Beszélgetés alvómódba",
      "RESOLVE_CONVERSATION": "Beszélgetés megoldása",
      "SEND_ATTACHMENT": "Send Attachment",
      "SEND_MESSAGE": "Send a Message",
      "CHANGE_PRIORITY": "Prioritás megváltoztatása",
      "ADD_PRIVATE_NOTE": "Add a Private Note",
      "SEND_WEBHOOK_EVENT": "Send Webhook Event"
    },
    "PRIORITY_TYPES": {
      "NONE": "Nincs",
      "LOW": "Alacsony",
      "MEDIUM": "Közepes",
      "HIGH": "Magas",
      "URGENT": "Sürgős"
    }
  }
}
